<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
<!--      <template v-slot:cell(joinDate)="data">-->
<!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
<!--      </template>-->
<!--      <template v-slot:cell(leaveDate)="data">-->
<!--        {{-->
<!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
<!--        }}-->
<!--      </template>-->
      <!--      <template v-slot:cell(price)="data">-->
      <!--        {{ Number(data.item.price).toFixed(2) }}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(estimateAmount)="data">-->
      <!--        {{ Number(data.item.estimateAmount).toFixed(2) }}-->
      <!--      </template>-->
            <template v-slot:cell(foreignAmount)="data">
              {{ data.item.foreignAmount != null ? Number(data.item.foreignAmount).toFixed(2) : '-' }}
            </template>
            <template v-slot:cell(amount)="data">
              {{ Number(data.item.amount).toFixed(2) }}
            </template>
      <template v-slot:cell(remark)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
            <template v-slot:foot()="scope">
              <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
            </template>
            <template v-slot:foot(index)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
            </template>
            <template v-slot:foot(amount)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amount')}}</div>
            </template>
            <template v-slot:foot(foreignAmount)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'foreignAmount')}}</div>
            </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";
export default {
  name: "itsBaseOverheadsDetail",
  data(){
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'expenseTypeLabel', label: '费项类别', width: '120px'},
        {key: 'expenseName', label: '费项名称', width: '120px'},
        {key: 'expatriatePlace', label: '外派地点', width: '120px'},
        {key: 'joinPeople', label: '参与人员', width: '120px'},
        {key: 'peopleNumber', label: '人数', width: '100px'},
        {key: 'reason', label: '事由', width: '120px'},
        {key: 'foreignAmount', label: '外币金额', width: '120px'},
        {key: 'amount', label: '金额（元）', width: '120px'},
        {key: 'remark', label: '备注', width: '130px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init(){

    },
    goBack(){
      this.$router.back()
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass(){
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>